<div class="row mt-2">
    <div class="col-lg-8 col-md-12 mb-4">
        <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
                <div class="card-title mb-0"><strong>Promotion Form <span class="text-muted fw-normal small">优惠表格</span></strong></div>
                <div *ngIf="data?.title || data?.type" class="text-end">
                    <span class="fw-bold me-2">{{ data?.title }}</span>
                    <span class="badge bg-primary" *ngIf="data?.type">{{ promotionTypeDisplay }}</span>
                </div>
            </div>
            <div class="card-body" *ngIf="!loading">
                <form #f="ngForm" (ngSubmit)="submit()" novalidate>
                    <div class="promotion-save-bar border rounded p-3 mb-3 bg-light">
                        <div class="d-flex flex-wrap align-items-end gap-3">
                            <div class="flex-grow-1">
                                <label for="status" class="form-label">Status 状态 <em>*</em></label>
                                <select class="form-control" id="status" name="status" #status="ngModel"
                                    [(ngModel)]="data.status" [disabled]="is_saving" required>
                                    <option [value]="1">Active 启用</option>
                                    <option [value]="0">Disabled 停用</option>
                                </select>
                            </div>
                            <button type="submit" class="btn btn-primary" [disabled]="is_saving || is_uploading">
                                {{ is_saving ? 'Saving... 保存中...' : is_uploading ? 'Uploading Image... 上传中...' : 'Save Promotion 保存优惠' }}
                            </button>
                        </div>
                        <p class="small mb-0 mt-2">Choose the status, then save to apply your changes. 选择状态后，请按保存。</p>
                        <p *ngIf="save_error || upload_error" class="text-danger mb-0 mt-2" role="alert">{{ save_error || upload_error }}</p>
                    </div>
                    <div class="accordion mb-4" id="promotionAccordion">
                        
                        <!-- 1. Promotion Info -->
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingInfo">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseInfo" aria-expanded="true" aria-controls="collapseInfo">
                                    <strong>1. Promotion Info <span class="text-muted fw-normal small">优惠信息</span></strong>
                                </button>
                            </h2>
                            <div id="collapseInfo" class="accordion-collapse collapse show" aria-labelledby="headingInfo"
                                data-bs-parent="#promotionAccordion">
                                <div class="accordion-body pb-1">
                                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="title" class="form-label">Title 标题 <em>*</em></label>
                                <input type="text" class="form-control" id="title" name="title" #title="ngModel"
                                    [(ngModel)]="data.title" required>
                                <div *ngIf="f.submitted && title.invalid" class="invalid-feedback">
                                    <div *ngIf="title.errors.required">Title is required 请填写标题</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="image" class="form-label">Image 图片</label>
                                <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'image', true)"
                                    (deleteEvent)="delete($event, 'image')"
                                    [loadImage]="data.image"></app-image-uploader>
                                <p class="mb-0 hint">Promotion banner image shown on frontend. 显示在前台的优惠横幅图片。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <app-checbox [setData]="data" [key]="'big_column_size'" [title]="'Big Column Size 大版面'"
                                    [value]="true"></app-checbox>
                                <p class="mb-0 hint">Enable to display this promotion in a wider card on frontend. 启用后，此优惠将以较大版面显示在前台。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="promotion_category_uuid" class="form-label">Promotion Category 优惠类别</label>
                                <ng-select #promotion_category_id="ngModel" id="promotion_category_uuid"
                                    name="promotion_category_uuid" [multiple]="false" bindLabel="title" bindValue="id"
                                    [items]="promotion_categories" [(ngModel)]="data.promotion_category_id">
                                </ng-select>
                                <p class="mb-0 hint">Optional. Group promotions under the same category on frontend. 可选，将相同类别的优惠归组显示在前台。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="type" class="form-label">Type 优惠类型 <em>*</em></label>
                                <select class="form-control" id="type" name="type" #type="ngModel"
                                    [(ngModel)]="data.type" required>
                                    <option [value]="'free-credit'">Free Credit (第一次开户口，不需要进钱)</option>
                                    <option [value]="'first-topup'">Welcome Bonus (第一次进分)</option>
                                    <!-- <option [value]="'daily-topup'">Daily Topup</option> -->
                                    <option [value]="'day-bonus'">Day Bonus (依据天进分)</option>
                                    <option [value]="'daily-checkin-bonus'">Daily Check In Bonus (每天签到)</option>
                                    <option [value]="'daily-deposit-bonus'">Daily Deposit Bonus</option>
                                    <option [value]="'daily-free-gift'">Daily Free Gift (每天免费送)</option>
                                    <option [value]="'monthly-bonus'">Monthly Bonus</option>
                                    <option [value]="'weekly-bonus'">Weekly Bonus</option>
                                    <option [value]="'downline-commission-bonus'">Downline Commission Bonus</option>
                                    <option [value]="'new-register'">New Register (第一次注册)</option>
                                    <option [value]="'happy-hour-bonus'">Happy Hour Bonus (优惠时间)</option>
                                    <option [value]="'daily-free-bonus'">Daily Free Bonus (每天免费Credit，无需进钱)</option>
                                    <option [value]="'daily-lost-bonus'">Daily Lost Bonus (每天输回扣)</option>
                                    <option [value]="'weekly-lost-bonus'">Weekly Lost Bonus (每周输回扣)</option>
                                    <option [value]="'monthly-lost-bonus'">Monthly Lost Bonus (每月输回扣)</option>
                                    <option [value]="'game-unlimted'">Game Unlimited (无限回扣)</option>
                                    <option [value]="'share-register-bonus'">Share Register Bonus (介绍Link得分)</option>
                                    <option [value]="'share-register-bonus-free-credit'">Share Register Bonus
                                        (介绍Link免费Credit,下线不需要进钱)</option>
                                    <option [value]="'referral-bonus'">Referral Bonus (推荐得分) Using Referral Wallet
                                    </option>
                                    <option [value]="'vip-bonus'">VIP Bonus (VIP等级得分)</option>
                                    <option [value]="'birthday-bonus'">Birthday Bonus (生日奖励)</option>
                                    <option [value]="'social-media-bonus'">Social Media Bonus (社交媒体奖励)</option>
                                    <!-- New Share Bonus = 介绍Link得分 -->
                                </select>
                                <div *ngIf="f.submitted && type.invalid" class="invalid-feedback">
                                    <div *ngIf="type.errors.required">Type is required 请选择优惠类型</div>
                                </div>
                                <p class="mb-0 hint">Select the promotion mechanism. Each type has different eligibility and claim rules. 选择优惠机制，每种类型有不同的资格与领取规则。</p>
                            </div>
                        </div>
                    </div>

                    <div class="row" *ngIf="data.type == 'daily-deposit-bonus'">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="sequence" class="form-label">Deposit Sequence 存款顺序 <em>*</em></label>
                                <select class="form-control" id="deposit_sequence" name="sequence" #sequence="ngModel"
                                    [(ngModel)]="data.sequence" required>
                                    <option [value]="1">1st Deposit 第一次存款</option>
                                    <option [value]="2">2nd Deposit 第二次存款</option>
                                    <option [value]="3">3rd Deposit 第三次存款</option>
                                    <option [value]="4">4th Deposit 第四次存款</option>
                                    <option [value]="5">5th Deposit 第五次存款</option>
                                </select>
                                <div *ngIf="f.submitted && sequence.invalid" class="invalid-feedback">
                                    <div *ngIf="sequence.errors.required">Deposit sequence is required 请选择存款顺序</div>
                                </div>
                                <p class="mb-0 hint">Which deposit of the day triggers this promotion. e.g. 2nd = only the player's 2nd deposit today qualifies. 选择当天第几次存款可领取此优惠。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="data.type == 'downline-commission-bonus'">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="sequence" class="form-label">Downline Deposit Count 下线存款次数 <em>*</em></label>
                                <select class="form-control" id="deposit_sequence" name="sequence" #sequence="ngModel"
                                    [(ngModel)]="data.sequence" required>
                                    <option *ngFor="let n of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28]" [value]="n">
                                        {{ n }}{{ n === 1 ? 'st' : n === 2 ? 'nd' : n === 3 ? 'rd' : 'th' }} Deposit 第{{ n }}次存款
                                    </option>
                                </select>
                                <div *ngIf="f.submitted && sequence.invalid" class="invalid-feedback">
                                    <div *ngIf="sequence.errors.required">Deposit count is required 请选择存款次数</div>
                                </div>
                                <p class="mb-0 hint">Trigger commission after downline's Nth deposit today. 下线当天第N次存款后发放佣金。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="data.type == 'share-register-bonus'">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="sequence" class="form-label">Max Claimable Referrals 最多可领推荐人数</label>
                                <input type="number" class="form-control" id="sequence" name="sequence"
                                    #sequence="ngModel" [(ngModel)]="data.sequence">
                                <p class="mb-0 hint">Maximum number of referred players this promotion can reward. Leave blank for unlimited. 此优惠最多可奖励的推荐人数，留空则不限制。</p>
                            </div>
                        </div>
                    </div>

                    <div class="row" *ngIf="data.type == 'daily-checkin-bonus'">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="sequence" class="form-label">Check-In Day 签到天数 <em>*</em></label>
                                <select class="form-control" id="checkin_sequence" name="sequence" #sequence="ngModel"
                                    [(ngModel)]="data.sequence" required>
                                    <option *ngFor="let n of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]" [value]="n">
                                        Day {{ n }} 第{{ n }}天
                                    </option>
                                </select>
                                <div *ngIf="f.submitted && sequence.invalid" class="invalid-feedback">
                                    <div *ngIf="sequence.errors.required">Check-in day is required 请选择签到天数</div>
                                </div>
                                <p class="mb-0 hint">Which day in the sequential check-in streak this promotion covers. Player must have claimed all previous days first. 此优惠对应连续签到的第几天，玩家须先完成前几天签到。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="game_id" class="form-label">Game 游戏 <em>*</em></label>
                                <ng-select id="game_id" name="game_id" [multiple]="true" bindLabel="title"
                                    bindValue="uuid" [items]="games" [clearable]="true" [placeholder]="'Select Game'"
                                    [(ngModel)]="data.game_id" #game_id="ngModel" required>
                                </ng-select>
                                <div *ngIf="f.submitted && game_id.invalid" class="invalid-feedback">
                                    <div *ngIf="game_id.errors.required">Game is required 请选择游戏</div>
                                </div>
                                <p class="mb-0 hint">Games this promotion applies to. Rolling/turnover is counted only in these games. 此优惠适用的游戏，返水也仅在这些游戏内计算。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="description" class="form-label">Description 描述 <em>*</em></label>
                                <quill-editor id="description" name="description_delta" #description="ngModel"
                                    [format]="'object'" [(ngModel)]="data.description_delta" [required]="true"
                                    [valueSetter]="editorValueSetter"
                                    [styles]="{minHeight: '250px'}"
                                    (onEditorCreated)="editorCreated($event, 'description_delta')"></quill-editor>
                                <div *ngIf="f.submitted && description.invalid" class="invalid-feedback">
                                    <div>Description is required</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="tnc" class="form-label">T&C 条款与条件</label>
                                <div class="mb-2">
                                    <label class="form-label text-muted small mb-1">T&C Banner Image 条款横幅图片 <span class="text-muted">(optional 可选, shown above T&C 显示于条款上方)</span></label>
                                    <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'tnc_image', true)"
                                        (deleteEvent)="delete($event, 'tnc_image')"
                                        [loadImage]="data.tnc_image"></app-image-uploader>
                                </div>
                                <quill-editor name="tnc_delta" #tnc="ngModel" [format]="'object'" [(ngModel)]="data.tnc_delta"
                                    [valueSetter]="editorValueSetter"
                                    [styles]="{minHeight: '250px'}"
                                    (onEditorCreated)="editorCreated($event, 'tnc_delta')"></quill-editor>
                                <p class="mb-0 hint">Optional. Add terms when this promotion has conditions beyond the description. 可选，如有额外条款可在此填写。</p>
                            </div>
                        </div>
                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 2. Promotion Detail -->
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingDetail">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseDetail" aria-expanded="false" aria-controls="collapseDetail">
                                    <strong>2. Promotion Detail <span class="text-muted fw-normal small">优惠详情</span></strong>
                                </button>
                            </h2>
                            <div id="collapseDetail" class="accordion-collapse collapse" aria-labelledby="headingDetail"
                                data-bs-parent="#promotionAccordion">
                                <div class="accordion-body pb-1">
                                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="from_date" class="form-label">Promotion Availability From 优惠开放日期（可选）</label>
                                <input type="date" class="form-control" id="from_date" name="from_date"
                                    #from_date="ngModel" [(ngModel)]="data.from_date">
                                <p class="mb-0 hint">Optional. Blank means no start restriction. Dates use Malaysia time (UTC+8). 可选，留空不限开始日期；使用马来西亚时间。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="to_date" class="form-label">Promotion Availability To 优惠截止日期（可选）</label>
                                <input type="date" class="form-control" id="to_date" name="to_date" #to_date="ngModel"
                                    [(ngModel)]="data.to_date">
                                <div *ngIf="f.submitted && data.to_date && data.from_date > data.to_date"
                                    class="invalid-feedback">
                                    <div>End date must be on or after start date 结束日期不能早于开始日期</div>
                                </div>
                                <p class="mb-0 hint">Optional. Includes the entire end date (UTC+8). Blank means no expiry. 可选，包含截止日全天；留空不限结束日期。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="data.type === 'new-register'">
                        <div class="col-12 mb-3">
                            <label for="register_from_date" class="form-label">Registered From 注册日期起（可选）</label>
                            <input type="date" class="form-control" id="register_from_date" name="register_from_date" [(ngModel)]="data.register_from_date">
                            <p class="mb-0 hint">Only players registered on or after this date can claim. Earlier accounts cannot claim, even with a deposit. Blank means no registration cutoff. 仅此日期起注册的玩家可领取，旧账号即使充值也不能领取；留空不限注册日期。</p>
                        </div>
                    </div>
                    <div class="row" *ngIf="data.type != 'new-register' && data.type != 'free-credit' && data.type != 'daily-lost-bonus' && data.type != 'weekly-lost-bonus' && data.type != 'monthly-lost-bonus'">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="min_deposit" class="form-label">Min Deposit 最低存款</label>
                                <input type="number" class="form-control" id="min_deposit" name="min_deposit"
                                    #min_deposit="ngModel" [(ngModel)]="data.min_deposit">
                                <div *ngIf="f.submitted && min_deposit.invalid" class="invalid-feedback">
                                    <div *ngIf="min_deposit.errors.required">Min deposit is required 请填写最低存款</div>
                                </div>
                                <p class="mb-0 hint">Minimum deposit required to be eligible for this promotion. Leave blank for no minimum. 领取此优惠所需的最低存款金额，留空则无限制。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="data.type == 'referral-bonus'">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="min_deposit" class="form-label">Min Referral Wallet Balance 最低推荐钱包余额</label>
                                <input type="number" class="form-control" id="min_deposit" name="min_deposit"
                                    #min_deposit="ngModel" [(ngModel)]="data.min_deposit">
                                <div *ngIf="f.submitted && min_deposit.invalid" class="invalid-feedback">
                                    <div *ngIf="min_deposit.errors.required">Min Referral Wallet Balance is required
                                    </div>
                                </div>
                                <p class="mb-0 hint">Minimum balance in the player's referral wallet to claim this bonus. Leave blank for no minimum. 玩家推荐钱包须达到的最低余额，留空则无限制。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="data.type != 'new-register'">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="max_wallet_balance" class="form-label">Max Wallet Balance 最高钱包余额</label>
                                <input type="number" class="form-control" id="max_wallet_balance"
                                    name="max_wallet_balance" #max_wallet_balance="ngModel"
                                    [(ngModel)]="data.max_wallet_balance">
                                <div *ngIf="f.submitted && max_wallet_balance.invalid" class="invalid-feedback">
                                    <div *ngIf="max_wallet_balance.errors.required">Max wallet balance is required</div>
                                </div>
                                <p class="mb-0 hint">Player cannot claim if their wallet balance exceeds this amount. Leave blank or enter 0 for no limit. 玩家钱包余额超过此金额则不可领取，留空或填 0 则无限制。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="data.type == 'daily-lost-bonus' || data.type == 'weekly-lost-bonus' || data.type == 'monthly-lost-bonus'">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="min_lose" class="form-label">Min Lose 最低输钱</label>
                                <input type="number" class="form-control" id="min_lose" name="min_lose"
                                    #min_lose="ngModel" [(ngModel)]="data.min_lose">
                                <div *ngIf="f.submitted && min_lose.invalid" class="invalid-feedback">
                                    <div *ngIf="min_lose.errors.required">Min lose is required</div>
                                </div>
                                <p class="mb-0 hint">Player must have lost at least this amount today to be eligible. Leave blank for no minimum. 玩家当天须输至少此金额才可领取，留空则无限制。</p>
                            </div>
                        </div>
                    </div>

                    <div class="row" *ngIf="data.type == 'happy-hour-bonus'">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="from_happy_hour" class="form-label">Happy Hour From 优惠时间（开始）<em>*</em></label>
                                <input type="time" class="form-control" id="from_happy_hour" name="from_happy_hour"
                                    #from_happy_hour="ngModel" [(ngModel)]="data.from_happy_hour" required>
                                <div *ngIf="f.submitted && from_happy_hour.invalid" class="invalid-feedback">
                                    <div *ngIf="from_happy_hour.errors.required">Happy hour start time is required 请设置优惠开始时间</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="data.type == 'happy-hour-bonus'">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="to_happy_hour" class="form-label">Happy Hour To 优惠时间（结束）</label>
                                <input type="time" class="form-control" id="to_happy_hour" name="to_happy_hour"
                                    #to_happy_hour="ngModel" [(ngModel)]="data.to_happy_hour">
                                <div *ngIf="f.submitted && data.to_happy_hour && data.from_happy_hour >= data.to_happy_hour"
                                    class="invalid-feedback">
                                    <div>End time must be after start time 结束时间须晚于开始时间</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="data.type == 'day-bonus'">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="day" class="form-label">Available Days 可领取的日子 <em>*</em></label>
                                <ng-select id="day" name="day" [multiple]="true" [items]="days" [clearable]="true"
                                    [placeholder]="'Select Days 选择日子'" [(ngModel)]="data.day" #day="ngModel" required>
                                </ng-select>
                                <div *ngIf="f.submitted && day.invalid" class="invalid-feedback">
                                    <div *ngIf="day.errors.required">Please select at least one day 请至少选择一天</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="player_level_id" class="form-label">Apply to Player / Agent Group 适用玩家／代理组</label>
                                <ng-select id="player_level_id" name="player_level_id"
                                    [multiple]="data.type != 'birthday-bonus' && data.type != 'vip-bonus' ? true : false"
                                    bindLabel="title" bindValue="id" [items]="player_levels"
                                    [(ngModel)]="data.player_level_id" #player_level_id="ngModel">
                                </ng-select>
                                <p class="mb-0 hint">Optional. Leave blank for all groups. Selected groups use their Promotion Audience setting in Player Level Management. For public offers, select the Default (Public) group. 可选，留空适用于所有组；指定组时依照该组的优惠适用对象。</p>
                            </div>
                        </div>
                    </div>
                                        <hr />
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="mb-3">
                                                    <label for="sort" class="form-label">Sort 排序 <i class="bi bi-sort-numeric-down text-muted"></i></label>
                                                    <input type="number" class="form-control" id="sort" name="sort" #sort="ngModel"
                                                        [(ngModel)]="data.sort">
                                                </div>
                                            </div>
                                        </div>

                                </div>
                            </div>
                        </div>

                        <!-- 3. Bonus -->
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingBonus">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseBonus" aria-expanded="false" aria-controls="collapseBonus">
                                    <strong>3. Bonus 奖励</strong>
                                </button>
                            </h2>
                            <div id="collapseBonus" class="accordion-collapse collapse" aria-labelledby="headingBonus"
                                data-bs-parent="#promotionAccordion">
                                <div class="accordion-body pb-1">
                                    <ng-container *ngIf="data.type != 'birthday-bonus' && data.type != 'referral-bonus'">
                        <div class="row">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="calculation" class="form-label">Calculation 计算方式 <em>*</em></label>
                                    <select class="form-control" id="calculation" name="calculation"
                                        #calculation="ngModel" [(ngModel)]="data.calculation" required>
                                        <option [value]=""
                                            *ngIf="data.type == 'share-register-bonus-free-credit' || data.type == 'share-register-bonus'">
                                            SELECT CALCULATION TYPE 请选择计算方式</option>
                                        <option [value]="'fixed'">Fixed 固定金额</option>
                                        <option [value]="'percentage'"
                                            *ngIf="data.type != 'share-register-bonus' && data.type != 'share-register-bonus-free-credit' && data.type != 'free-credit'">
                                            Percentage 百分比</option>
                                        <option [value]="'share-register'"
                                            *ngIf="data.type == 'share-register-bonus' && data.type == 'share-register-bonus-free-credit'">
                                            Each Register 每位推荐</option>
                                    </select>
                                    <div *ngIf="f.submitted && calculation.invalid" class="invalid-feedback">
                                        <div *ngIf="calculation.errors.required">Calculation is required 请选择计算方式</div>
                                    </div>
                                    <p class="mb-0 hint">
                                        <strong>Fixed 固定:</strong> Player receives a flat bonus amount. 玩家获得固定奖励金额。<br>
                                        <strong>Percentage 百分比:</strong> Bonus is a % of deposit/loss/wallet. 奖励为存款/输钱/钱包的百分比。
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="bonus" class="form-label">Bonus 奖励金额 <em>*</em> {{data.calculation == "percentage" ? "(%)" : "(RM)"}}</label>
                                    <input type="text" class="form-control" id="bonus" name="bonus" #bonus="ngModel"
                                        [(ngModel)]="data.bonus" required>
                                    <div *ngIf="f.submitted && bonus.invalid" class="invalid-feedback">
                                        <div *ngIf="bonus.errors.required">Bonus is required 请填写奖励金额</div>
                                    </div>
                                    <p class="mb-0 hint">{{data.calculation == "percentage" ? "Example: Customer Deposit
                                        RM 20.00, Bonus = RM " + (20 * data.bonus / 100) : "Bonus = RM " + data.bonus}}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="data.calculation == 'percentage'">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="bonus_type" class="form-label">Max Bonus 最高奖励 (RM)</label>
                                    <input type="number" class="form-control" id="max_bonus" name="max_bonus"
                                        #max_bonus="ngModel" [(ngModel)]="data.max_bonus">
                                    <div *ngIf="f.submitted && max_bonus.invalid" class="invalid-feedback">
                                        <div *ngIf="max_bonus.errors.required">Max bonus is required</div>
                                    </div>
                                    <p class="mb-0 hint">Cap the bonus amount. e.g. 10% of RM 1000 = RM 100, but if max bonus = RM 30, player gets RM 30. Leave blank for no cap. 奖励上限，留空则无限制。例：10% × RM1000 = RM100，若最高奖励为RM30，则只获得RM30。</p>
                                </div>
                            </div>
                        </div>
                        <p class="mb-0 hint">示例 Example:</p>
                        <ul>
                            <li>Fixed 固定: Bonus = RM 100 → Player gets RM 100 玩家获得RM100</li>
                            <li>Percentage 百分比: 10%, Deposit RM 1000 → Bonus = RM 100 存款RM1000，奖励RM100</li>
                            <li>Percentage + Max Bonus 百分比+上限: 10%, Deposit RM 1000, Max RM 30 → Bonus = RM 30 奖励上限RM30</li>
                        </ul>
                    </ng-container>

                                </div>
                            </div>
                        </div>

                        <!-- 4. Rolling Target -->
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingTarget">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTarget" aria-expanded="false" aria-controls="collapseTarget">
                                    <strong>4. Rolling Target 返水要求</strong>
                                </button>
                            </h2>
                            <div id="collapseTarget" class="accordion-collapse collapse" aria-labelledby="headingTarget"
                                data-bs-parent="#promotionAccordion">
                                <div class="accordion-body pb-1">
                                    <p class="text-muted"><i class="bi bi-info-circle me-1"></i> Conditions the player must meet before they can withdraw. 玩家须完成以下条件才可提款。</p>
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="calculate_by" class="form-label">Calculate By 返水方式 <em>*</em></label>
                                <select class="form-control" id="calculate_by" name="calculate_by"
                                    #calculate_by="ngModel" [(ngModel)]="data.calculate_by" required>
                                    <option [value]="'rolling'">Rolling % 返水百分比（只算输）</option>
                                    <option [value]="'turnover'">Turnover Multiplier 流水倍数（全部下注）</option>
                                    <option [value]="'rolling-fixed'">Rolling Fixed 固定返水（只算输）</option>
                                    <option [value]="'turnover-fixed'">Turnover Fixed 固定流水（全部下注）</option>
                                    <option [value]="'wallet-balance'">Wallet Balance 钱包余额门槛</option>
                                </select>
                                <div *ngIf="f.submitted && calculate_by.invalid" class="invalid-feedback">
                                    <div *ngIf="calculate_by.errors.required">Please select a calculate type 请选择返水方式</div>
                                </div>
                                <div class="hint mt-2 mb-0" style="line-height: 1.6;">
                                    &bull; <strong>Turnover 全部下注:</strong> All bets count toward the target. 全部下注金额计入返水目标。<br>
                                    &bull; <strong>Rolling 只算输:</strong> Only losing bets count. 只有输掉的下注计入返水目标。<br>
                                    &bull; <strong>% Multiplier 倍数:</strong> Target = (Deposit + Wallet + Bonus) × multiplier. 目标 = (存款 + 钱包 + 奖励) × 倍数。<br>
                                    &bull; <strong>Fixed 固定:</strong> Static target regardless of amounts. 无论金额多少，目标固定不变。<br>
                                    &bull; <strong>Wallet Balance 钱包余额:</strong> No bet counting — player can withdraw once their wallet balance reaches the set threshold. 无需计算下注，钱包余额达到门槛即可提款。
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="data.calculate_by">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="min_trigger" class="form-label">
                                    <ng-container *ngIf="data.calculate_by === 'wallet-balance'">Wallet Balance Threshold 钱包余额门槛 (RM)</ng-container>
                                    <ng-container *ngIf="data.calculate_by !== 'wallet-balance'">
                                        {{data.calculate_by == 'rolling' || data.calculate_by == 'rolling-fixed' ? 'Rolling 返水' : 'Turnover 返水'}}
                                        {{data.calculate_by == 'rolling-fixed' || data.calculate_by == 'turnover-fixed' ? 'Fixed Amount 固定金额' : 'Multiplier 倍数'}}
                                    </ng-container>
                                    <em>*</em>
                                </label>
                                <input type="number" class="form-control" id="min_trigger" name="min_trigger"
                                    #min_trigger="ngModel" [(ngModel)]="data.min_trigger" required>
                                <div *ngIf="f.submitted && min_trigger.invalid" class="invalid-feedback">
                                    <div *ngIf="min_trigger.errors.required">This field is required 此栏位必填</div>
                                </div>
                                <p class="mb-0 hint" *ngIf="data.calculate_by === 'turnover' || data.calculate_by === 'rolling'">
                                    e.g. Multiplier 倍数 = 10, Bonus RM100 + Wallet RM1000 → Target = RM1100 × 10 = RM11000 before withdraw.<br>
                                    例：倍数10，奖励RM100 + 钱包RM1000 → 须下注达RM11000才可提款。
                                </p>
                                <p class="mb-0 hint" *ngIf="data.calculate_by === 'turnover-fixed' || data.calculate_by === 'rolling-fixed'">
                                    Fixed target: RM {{ data.min_trigger || 0 }} in the selected games before withdrawal.
                                    固定目标：在所选游戏完成 RM {{ data.min_trigger || 0 }} 才可提款。
                                </p>
                                <p class="mb-0 hint" *ngIf="data.calculate_by === 'wallet-balance'">
                                    Player can withdraw once their wallet balance reaches this amount. No bet counting required.<br>
                                    玩家钱包余额达到此金额后即可提款，无需计算下注。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="min_withdraw_type" class="form-label">Min Withdraw Type 最低提款方式</label>
                                <select class="form-control" id="min_withdraw_type" name="min_withdraw_type"
                                    #min_withdraw_type="ngModel" [(ngModel)]="data.min_withdraw_type">
                                    <option [value]="'fixed'">Fixed 固定金额 (RM)</option>
                                    <option [value]="'percentage-bonus'">% of Bonus 奖励百分比</option>
                                    <option [value]="'percentage-wallet-bonus'">% of Wallet + Bonus 钱包+奖励百分比</option>
                                </select>
                                <p class="mb-0 hint">
                                    <strong>Fixed 固定:</strong> e.g. RM 50 → player must have ≥ RM 50 to withdraw. 玩家须有至少RM50才可提款。<br>
                                    <strong>% of Bonus 奖励%:</strong> e.g. bonus RM 100, 30% → min withdraw = RM 30. 奖励RM100，30% → 最低提款RM30。<br>
                                    <strong>% of Wallet+Bonus 钱包+奖励%:</strong> e.g. wallet RM 200 + bonus RM 100, 30% → RM 90. 钱包RM200+奖励RM100，30% → 最低提款RM90。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="min_withdraw" class="form-label">
                                    Min Withdraw 最低提款
                                    <span *ngIf="!data.min_withdraw_type || data.min_withdraw_type === 'fixed'" class="text-muted small">(RM)</span>
                                    <span *ngIf="data.min_withdraw_type === 'percentage-bonus'" class="text-muted small">(% 奖励百分比)</span>
                                    <span *ngIf="data.min_withdraw_type === 'percentage-wallet-bonus'" class="text-muted small">(% 钱包+奖励百分比)</span>
                                </label>
                                <input type="number" class="form-control" id="min_withdraw" name="min_withdraw"
                                    #min_withdraw="ngModel" [(ngModel)]="data.min_withdraw">
                                <div *ngIf="f.submitted && min_withdraw.invalid" class="invalid-feedback">
                                    <div *ngIf="min_withdraw.errors.required">Min withdraw is required 请填写最低提款</div>
                                </div>
                                <p class="mb-0 hint" *ngIf="!data.min_withdraw_type || data.min_withdraw_type === 'fixed'">
                                    Fixed RM value. Leave blank for no minimum. 固定RM金额，留空则无最低提款限制。
                                </p>
                                <p class="mb-0 hint" *ngIf="data.min_withdraw_type === 'percentage-bonus'">
                                    Enter percentage (%). e.g. 30 → bonus RM 100, min withdraw = RM 30. 输入百分比，例：30 → 奖励RM100，最低提款RM30。
                                </p>
                                <p class="mb-0 hint" *ngIf="data.min_withdraw_type === 'percentage-wallet-bonus'">
                                    Enter percentage (%). e.g. 30 → wallet RM 200 + bonus RM 100 = RM 300, min withdraw = RM 90. 输入百分比，例：30 → 钱包RM200+奖励RM100=RM300，最低提款RM90。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="max_withdraw" class="form-label">Max Withdraw 最高提款 (RM)</label>
                                <input type="number" class="form-control" id="max_withdraw" name="max_withdraw"
                                    #max_withdraw="ngModel" [(ngModel)]="data.max_withdraw">
                                <div *ngIf="f.submitted && max_withdraw.invalid" class="invalid-feedback">
                                    <div *ngIf="max_withdraw.errors.required">Max withdraw is required 请填写最高提款</div>
                                </div>
                                <p class="mb-0 hint">Cap on total profit from this promotion. Excess will be deducted at withdrawal. Leave blank for no cap. 此优惠的最高盈利上限，超出部分提款时将被扣除，留空则无限制。</p>
                            </div>
                        </div>
                    </div>
                                </div>
                            </div>
                        </div>
                    </div> <!-- End Accordion -->
                    <button type="submit" class="btn btn-primary w-100 btn-lg shadow-sm" [disabled]="is_saving || is_uploading">
                        {{ is_saving ? 'Saving... 保存中...' : is_uploading ? 'Uploading Image... 上传中...' : 'Update Promotion 更新优惠' }}
                    </button>
                </form>
            </div>
            <div class="card-body py-5 text-center" *ngIf="loading">
                <div class="loading-container p-5">
                    <div class="spinner-wrapper mb-4">
                        <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"></div>
                        <div class="spinner-pulse"></div>
                    </div>
                    <h5 class="fw-bold text-primary mb-1">Syncing Promotion Data</h5>
                    <p class="text-muted small">Please wait while we prepare the editor...</p>
                </div>
            </div>
        </div>
    </div>

    <!-- Promotion Simulator Card / 优惠模拟器 -->
    <div class="col-lg-4 col-md-12 d-none d-md-block align-self-start sticky-top" style="top: 80px; z-index: 1020;">
        <div class="card shadow-sm">
            <div class="card-header bg-light d-flex flex-column">
                <div class="card-title mb-2">
                    <strong><i class="bi bi-calculator"></i> Promotion Simulator &nbsp;<span class="text-muted fw-normal small">优惠模拟器</span></strong>
                </div>
                <div class="p-2 bg-white rounded border border-light shadow-sm text-center" *ngIf="data?.title || data?.type">
                    <h6 class="mb-1 text-primary fw-bold">{{ data?.title || 'Untitled Promotion' }}</h6>
                    <span class="badge bg-secondary">{{ promotionTypeDisplay }}</span>
                </div>
            </div>
            <div class="card-body">

                <!-- ── INPUTS: contextual per promotion type ── -->

                <!-- Deposit input (most types) / 存款金额 -->
                <div class="mb-3" *ngIf="isDepositRequired && !needsLossInput && !needsReferralCountInput && !needsReferralWalletInput && !needsDownlineInput">
                    <label class="form-label fw-bold">Simulated Deposit <span class="text-muted fw-normal">模拟存款</span></label>
                    <div class="input-group">
                        <span class="input-group-text">RM</span>
                        <input type="number" class="form-control" [(ngModel)]="simulatedDeposit" name="simDeposit" min="0">
                    </div>
                    <small class="text-muted">Min required: RM {{ data.min_deposit || 0 }} &nbsp;|&nbsp; 最低存款: RM {{ data.min_deposit || 0 }}</small>
                </div>

                <!-- Loss amount input (daily-lost-bonus, game-unlimted) / 输钱金额 -->
                <div class="mb-3" *ngIf="needsLossInput">
                    <label class="form-label fw-bold">Simulated Loss Amount <span class="text-muted fw-normal">模拟输钱金额</span></label>
                    <div class="input-group">
                        <span class="input-group-text">RM</span>
                        <input type="number" class="form-control" [(ngModel)]="simulatedLossAmount" name="simLoss" min="0">
                    </div>
                    <small class="text-muted">Min loss required: RM {{ data.min_lose || 0 }} &nbsp;|&nbsp; 最低输钱: RM {{ data.min_lose || 0 }}</small>
                </div>

                <!-- Referral count input (share-register types) / 推荐人数 -->
                <div class="mb-3" *ngIf="needsReferralCountInput">
                    <label class="form-label fw-bold">Simulated Referral Count <span class="text-muted fw-normal">模拟推荐人数</span></label>
                    <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-people"></i></span>
                        <input type="number" class="form-control" [(ngModel)]="simulatedReferralCount" name="simReferral" min="1">
                    </div>
                    <small class="text-muted">Bonus per referral: RM {{ data.bonus || 0 }} &nbsp;|&nbsp; 每位推荐: RM {{ data.bonus || 0 }}</small>
                </div>

                <!-- Referral wallet balance input (referral-bonus) / 推荐钱包余额 -->
                <div class="mb-3" *ngIf="needsReferralWalletInput">
                    <label class="form-label fw-bold">Simulated Referral Wallet <span class="text-muted fw-normal">推荐钱包余额</span></label>
                    <div class="input-group">
                        <span class="input-group-text">RM</span>
                        <input type="number" class="form-control" [(ngModel)]="simulatedReferralWallet" name="simRefWallet" min="0">
                    </div>
                    <small class="text-muted">Min balance: RM {{ data.min_deposit || 0 }} &nbsp;|&nbsp; 最低余额: RM {{ data.min_deposit || 0 }}</small>
                </div>

                <!-- Downline count input (downline-commission-bonus) / 下线人数 -->
                <div class="mb-3" *ngIf="needsDownlineInput">
                    <label class="form-label fw-bold">Simulated Downline Count <span class="text-muted fw-normal">模拟下线人数</span></label>
                    <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-diagram-3"></i></span>
                        <input type="number" class="form-control" [(ngModel)]="simulatedDownlineCount" name="simDownline" min="1">
                    </div>
                    <small class="text-muted">Each downline deposited: RM {{ data.min_deposit || 0 }} &nbsp;|&nbsp; 每位下线存款: RM {{ data.min_deposit || 0 }}</small>
                </div>

                <!-- Wallet balance (always shown) / 钱包余额 -->
                <div class="mb-4">
                    <label class="form-label fw-bold">Simulated Wallet Balance <span class="text-muted fw-normal">模拟钱包余额</span></label>
                    <div class="input-group">
                        <span class="input-group-text">RM</span>
                        <input type="number" class="form-control" [(ngModel)]="simulatedWalletBalance" min="0">
                    </div>
                    <small class="text-muted" *ngIf="data.max_wallet_balance && +data.max_wallet_balance !== 0">
                        Max allowed: RM {{ data.max_wallet_balance }} &nbsp;|&nbsp; 最高余额限制: RM {{ data.max_wallet_balance }}
                    </small>
                    <small class="text-muted" *ngIf="!data.max_wallet_balance || +data.max_wallet_balance === 0">
                        Adjust to test eligibility &nbsp;|&nbsp; 输入金额以测试资格
                    </small>
                </div>

                <!-- ── RESULTS ── -->
                <div class="calculator-results p-3 bg-light rounded border">
                    <ng-container *ngIf="isSimulatorSupported; else unsupportedPromotion">

                        <!-- Eligibility gate -->
                        <ng-container *ngIf="eligibilityStatus.eligible; else ineligibleBlock">

                            <!-- Bonus row / 预计奖励 -->
                            <div class="mb-3">
                                <div class="d-flex justify-content-between align-items-start">
                                    <div>
                                        <label class="form-label fw-bold text-success mb-0">Expected Bonus 预计奖励</label>
                                        <br>
                                        <small class="text-muted" *ngIf="data.calculation === 'fixed'">Fixed 固定 RM {{ data.bonus || 0 }}</small>
                                        <small class="text-muted" *ngIf="data.calculation === 'percentage'">
                                            {{ data.bonus || 0 }}% of {{ needsLossInput ? 'Loss 输钱' : (isDepositRequired ? 'Deposit 存款' : 'Wallet 钱包') }}
                                            <ng-container *ngIf="data.max_bonus > 0"> (Max RM {{ data.max_bonus }})</ng-container>
                                        </small>
                                        <small class="text-muted" *ngIf="data.calculation === 'share-register'">
                                            {{ simulatedReferralCount }} referral(s) 推荐人数 × RM {{ data.bonus || 0 }}
                                        </small>
                                        <small class="text-muted" *ngIf="data.type === 'referral-bonus'">
                                            Full referral wallet transfer 推荐钱包全额转入
                                        </small>
                                    </div>
                                    <h3 class="text-success mb-0 ms-2">RM {{ simulatedBonus | number:'1.2-2' }}</h3>
                                </div>
                            </div>

                            <!-- Wallet after bonus row / 奖励后钱包余额 -->
                            <div class="mb-3">
                                <div class="d-flex justify-content-between align-items-center">
                                    <small class="text-muted">Wallet after bonus 奖励后余额</small>
                                    <span class="fw-bold">RM {{ simulatedWalletAfterBonus | number:'1.2-2' }}</span>
                                </div>
                            </div>

                            <hr class="my-2">

                            <!-- Rolling/Turnover target row / 返水要求 -->
                            <div class="mb-3">
                                <div class="d-flex justify-content-between align-items-start">
                                    <div>
                                        <label class="form-label fw-bold text-danger mb-0">
                                            <ng-container *ngIf="data.calculate_by === 'rolling' || data.calculate_by === 'rolling-fixed'">
                                                Rolling 返水 <span class="badge bg-danger ms-1 small">只算输</span>
                                            </ng-container>
                                            <ng-container *ngIf="data.calculate_by === 'turnover' || data.calculate_by === 'turnover-fixed'">
                                                Turnover 返水 <span class="badge bg-warning text-dark ms-1 small">全部下注</span>
                                            </ng-container>
                                            <ng-container *ngIf="data.calculate_by === 'wallet-balance'">
                                                Wallet Balance 钱包余额门槛 <span class="badge bg-info text-dark ms-1 small">余额达标</span>
                                            </ng-container>
                                            <ng-container *ngIf="!data.calculate_by">返水要求</ng-container>
                                        </label>
                                        <br>
                                        <small class="text-muted" *ngIf="data.calculate_by === 'turnover' || data.calculate_by === 'rolling'">
                                            ({{ isDepositRequired && !needsLossInput ? 'Deposit + ' : '' }}Wallet + Bonus) × {{ data.min_trigger || 0 }}
                                        </small>
                                        <small class="text-muted" *ngIf="data.calculate_by === 'turnover-fixed' || data.calculate_by === 'rolling-fixed'">
                                            Fixed 固定返水目标: RM {{ data.min_trigger || 0 }}
                                        </small>
                                        <small class="text-muted" *ngIf="data.calculate_by === 'wallet-balance'">
                                            Withdraw when wallet ≥ RM {{ data.min_trigger || 0 }} 钱包余额达到 RM {{ data.min_trigger || 0 }} 可提款
                                        </small>
                                        <small class="text-warning" *ngIf="!data.calculate_by">Please select calculate type 请选择返水方式</small>
                                    </div>
                                    <h3 class="text-danger mb-0 ms-2">
                                        {{ simulatedTarget === 0 ? 'N/A' : ('RM ' + (simulatedTarget | number:'1.2-2')) }}
                                    </h3>
                                </div>
                            </div>

                            <!-- Min Withdraw row / 最低提款 -->
                            <div class="mb-3" *ngIf="data.min_withdraw > 0">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <small class="fw-bold">Min Withdraw 最低提款</small><br>
                                        <small class="text-muted">{{ simulatedMinWithdrawLabel }}</small>
                                    </div>
                                    <span class="fw-bold text-warning">RM {{ simulatedMinWithdraw | number:'1.2-2' }}</span>
                                </div>
                            </div>

                            <!-- Max Withdraw row / 最高提款 -->
                            <div class="mb-0" *ngIf="data.max_withdraw > 0">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <small class="fw-bold">Max Withdraw Cap 最高提款上限</small><br>
                                        <small class="text-danger" *ngIf="maxWithdrawExceeded">
                                            ⚠️ Bonus exceeds cap — excess will be deducted 奖励超出上限，多余将被扣除
                                        </small>
                                        <small class="text-success" *ngIf="!maxWithdrawExceeded">Within cap 在上限内</small>
                                    </div>
                                    <span class="fw-bold" [class.text-danger]="maxWithdrawExceeded" [class.text-success]="!maxWithdrawExceeded">
                                        RM {{ data.max_withdraw | number:'1.2-2' }}
                                    </span>
                                </div>
                            </div>

                            <!-- Happy hour window info / 优惠时间 -->
                            <div class="mt-2" *ngIf="data.type === 'happy-hour-bonus' && data.from_happy_hour && data.to_happy_hour">
                                <small class="text-muted"><i class="bi bi-clock me-1"></i>
                                    Happy Hour 优惠时间: {{ data.from_happy_hour }} – {{ data.to_happy_hour }} (MYT UTC+8)
                                </small>
                            </div>

                            <!-- Day bonus availability / 可领取的日子 -->
                            <div class="mt-2" *ngIf="data.type === 'day-bonus' && data.day?.length">
                                <small class="text-muted"><i class="bi bi-calendar-week me-1"></i>
                                    Available days 可领取的日子: {{ data.day.join(', ') }}
                                </small>
                            </div>

                        </ng-container>

                        <!-- Ineligible state / 不符合资格 -->
                        <ng-template #ineligibleBlock>
                            <div class="text-center py-3">
                                <i class="bi bi-lock text-muted fs-3 d-block mb-2"></i>
                                <span class="fw-bold text-muted">Not Eligible 不符合资格</span>
                            </div>
                        </ng-template>

                    </ng-container>

                    <!-- Unsupported type fallback -->
                    <ng-template #unsupportedPromotion>
                        <div class="text-center py-4">
                            <i class="bi bi-tools text-warning fs-3 d-block mb-2"></i>
                            <span class="text-muted fw-bold">Simulator Under Review 模拟器待更新</span>
                        </div>
                    </ng-template>
                </div>

                <!-- Eligibility alert / 资格提示 -->
                <ng-container *ngIf="isSimulatorSupported">
                    <div class="alert alert-success mt-3 mb-0 py-2" *ngIf="eligibilityStatus.eligible">
                        <small><strong><i class="bi bi-check-circle"></i> Eligible 符合资格</strong> — {{ eligibilityStatus.message }}</small>
                    </div>
                    <div class="alert alert-danger mt-3 mb-0 py-2" *ngIf="!eligibilityStatus.eligible">
                        <small><strong><i class="bi bi-x-circle"></i> Not Eligible 不符合资格:</strong> {{ eligibilityStatus.message }}</small>
                    </div>
                </ng-container>

                <div class="alert alert-info mt-3 mb-0 py-2">
                    <small><i class="bi bi-info-circle me-1"></i>
                        Live preview based on current unsaved form values. 根据当前表单数值实时预览。
                    </small>
                </div>

            </div>
        </div>
    </div>
</div>
